<app-compliance-nav [activeMenuItem]="'chargebacks'"></app-compliance-nav>


<mat-card class="content-card">
  <div class="header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="10px">

      </div>
    </div>
    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="table">
        <app-date-edit class="date-field" placeholder="Start date" #startDateFilter="ngModel" [(ngModel)]="table.filters.startFilterDate"></app-date-edit>
        <app-date-edit class="date-field" placeholder="End date" #endDateFilter="ngModel" [(ngModel)]="table.filters.endFilterDate"></app-date-edit>
        <mat-form-field class="date-filter-field">
          <mat-select placeholder="Date filters" [(ngModel)]="table.filters.dateFilterCols" multiple>
            <mat-option *ngFor="let dateFilter of dateFiltersList" [value]="dateFilter.name">
              {{dateFilter.header}}
            </mat-option>
          </mat-select>
        </mat-form-field>


        <mat-form-field>
          <mat-label>Status</mat-label>
          <mat-select placeholder="Chargeback status" [(ngModel)]="table.filters.someAdditionalData" multiple>
            <mat-option [value]="chargebackStatus.Request">Requested</mat-option>
            <mat-option [value]="chargebackStatus.Pending">Pending</mat-option>
            <mat-option [value]="chargebackStatus.Denied">Denied</mat-option>
            <mat-option [value]="chargebackStatus.SuccessPending">Success - Pending</mat-option>
            <mat-option [value]="chargebackStatus.ChargebackExecuted">Charged back</mat-option>


          </mat-select>
        </mat-form-field>

        <mat-form-field class="search-field">
          <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                 [(ngModel)]="table.filters.str">
        </mat-form-field>
        <button #searchButton mat-icon-button (click)="onSearch()" [disabled]="startDateFilter.invalid || endDateFilter.invalid">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button (click)="table.clearFilter()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <app-mat-table-generator #table
                           tableName="chargebacksTable"
                           [saveFilters]="true"
                           [useEmbededFilter]="false"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="false"
                           [deleteEnabled]="false"
                           [multiselectEnabled]="true"
                           [viewLink]="getViewLink"
                           [customActions]=""
                           [editLink]="getEditLink" >
  </app-mat-table-generator>
</mat-card>
